export default __webpack_public_path__ + "static/media/slidermobile3.33a486d1.jpg";